import React from "react";
import '../css/PopupModal.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PopupModal = ({
  titleStyle,
  title,
  message,
  children,         
  onClose,
  isVisible,
  icon,
  iconColor = "#28a745",
  iconBorder,
  confirmText,
  onConfirm
}) => {
  if (!isVisible) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  return (
    <div className="popup-modal-overlay">
      <div className="popup-modal-content">

        {/* Fixed Header - Icon and Title */}
        <div className="popup-modal-header">
          {icon && (
            <div className={iconBorder} style={{ color: iconColor }}>
              <FontAwesomeIcon icon={icon} size="3x"/>
            </div>
          )}
          <h4 className={titleStyle}>{title}</h4>
        </div>

        {/* Scrollable Body */}
        <div className="popup-modal-body">
          {children
            ? children
            : <p className="popup-modal-message">{message}</p>
          }
        </div>

        {/* Fixed Footer - OK Button */}
        <div className="popup-modal-footer">
          <button className="popup-modal-button" onClick={handleConfirm}>
            {confirmText || 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;